import { Component, EventEmitter, OnInit, signal, WritableSignal , Output, Input} from '@angular/core'
import { CommonModule } from '@angular/common'
import { BillingService } from 'src/app/services/billing.service'
import { PaymentProfile } from 'src/types/billing'
import { MatButtonModule } from '@angular/material/button'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { FormGroup } from '@angular/forms'
import { CreditCardFormComponent } from '../credit.card.form/credit.card.form.component'

@Component({
	selector: 'gwc-payment-profiles',
	templateUrl: './payment.profiles.component.html',
	styleUrls: ['./payment.profiles.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    CreditCardFormComponent
	]
})

export class PaymentProfilesComponent implements OnInit {
	@Output() public onProfileSelected: EventEmitter<string> = new EventEmitter<string>()
  @Input() public ccForm!: FormGroup

	public paymentProfiles: WritableSignal<PaymentProfile[]> = signal<PaymentProfile[]>([])
	public selectedProfile: WritableSignal<string | null> = signal<string | null>(null)
	public isLoading: WritableSignal<boolean> = signal<boolean>(false)
	public error: WritableSignal<string | null> = signal<string | null>(null)
  public mode: WritableSignal<'profiles' | 'add-card'> = signal<'profiles' | 'add-card'>('profiles')

	constructor(
		private billingService: BillingService
	) { }

	ngOnInit(): void {
		this.loadPaymentProfiles()
	}

	public selectProfile(uuid: string): void {
		this.selectedProfile.set(uuid)
		this.onProfileSelected.emit(uuid)
	}

	private loadPaymentProfiles(): void {
		this.isLoading.set(true)
		this.error.set(null)

		this.billingService.getPaymentProfiles()
			.subscribe({
				next: (profiles: PaymentProfile[]) => {
          console.log('profiles', profiles)
          profiles.map(profile => {
            profile.brand = profile.brand.toLowerCase()
            profile.last4 = profile.last4.replace('XXXX', '')
          })
					this.paymentProfiles.set(profiles)


					if (profiles.length === 0) {
						this.mode.set('add-card')
						this.selectedProfile.set(null)
						this.onProfileSelected.emit(undefined)
					} else {
						this.selectedProfile.set(profiles[0].uuid)
						this.onProfileSelected.emit(profiles[0].uuid)
					}
					
					this.isLoading.set(false)
				},
				error: (error) => {
					this.error.set('Failed to load payment profiles')
					this.isLoading.set(false)
					console.error('Error loading payment profiles:', error)
				}
			})
	}

  public addNewCard(): void {
    this.mode.set('add-card')
		this.selectedProfile.set(null)
		this.onProfileSelected.emit(undefined)
  }

	public cancelNewCard(): void {
		this.mode.set('profiles')
		this.ccForm.reset()

		const firstProfile = this.paymentProfiles()[0]
		this.selectedProfile.set(firstProfile.uuid)
		this.onProfileSelected.emit(firstProfile.uuid)
	}
}
